module.exports = __webpack_public_path__ + "static/media/10285.dcf12c3c.jpg";